import { MensajesGenericos_ES } from './Genericos/DiccionarioMensajesGenericos_ES';
import { DiccionarioAcademico_ES } from './DiccionariosAreas/DiccionarioAcademico_ES';
import { DiccionarioSeguridad_ES } from './DiccionariosAreas/DiccionarioSeguridad_ES';
import { DiccionarioLogin_ES } from './DiccionariosAreas/DiccionarioLogin_ES';
import { DiccionarioCajas_ES } from './DiccionariosAreas/DiccionarioCajas_ES';

const DiccionarioInterno = [
    {
        'codigo': 'ErrorValidUUID',
        'mensaje': 'Token de validación no valido'
    },
    {
        'codigo': 'ErrorValidFormatUUID',
        'mensaje': 'Formato del token de validación no valido'
    },
    {
        'codigo': 'ErrorRequiredEmail',
        'mensaje': 'No tiene un correo asociado a su cuenta de usuario. Contactar con la administración.'
    }, 
    {
        'codigo': 'SussesEmailSend',
        'mensaje': 'Código de verificación enviado satisfactoriamente a su cuenta de correo.'
    },
    {
        'codigo': 'ErrorExistsClient',
        'mensaje': 'Ya existe otro estudiante con esa identificación.'
    },
    {
        'codigo': 'DuplicateCustomerEmailNI',
        'mensaje': 'El correo electrónico ingresado no se encuentra disponible. Contactar con la administración.'
    },
];

export const DiccionarioMensajes_ES = [...DiccionarioInterno, ...MensajesGenericos_ES, ...DiccionarioLogin_ES,
    ...DiccionarioAcademico_ES, ...DiccionarioSeguridad_ES, ...DiccionarioCajas_ES];